import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';

const logos = [
  'Acme Corp', 'GlobalRetail', 'TechFlow', 'StudioX', 
  'VyaparTech', 'NextGen AI', 'BlueOcean', 'FinServe', 
  'LedgerPro', 'UrbanMart'
];

const SocialMarquee = () => {
  return (
    <div className="border-t border-gray-100 bg-white/50 backdrop-blur-sm py-8 relative z-10 w-full">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <p className="text-center text-[11px] font-bold tracking-widest text-gray-400 uppercase mb-8">
          TRUSTED BY INNOVATIVE TEAMS AND MSMEs ACROSS INDIA
        </p>
        <div className="opacity-40 grayscale hover:grayscale-0 hover:opacity-80 transition-all duration-500">
          <Swiper
            modules={[Autoplay]}
            spaceBetween={40}
            slidesPerView={3}
            breakpoints={{
              640: { slidesPerView: 4 },
              768: { slidesPerView: 5 },
              1024: { slidesPerView: 6 },
            }}
            loop={true}
            autoplay={{
              delay: 0,
              disableOnInteraction: false,
            }}
            speed={4000}
            className="mySwiper flex items-center swiper-linear"
          >
            {logos.map((logo, i) => (
              <SwiperSlide key={i}>
                <div className="flex justify-center text-lg font-extrabold text-gray-800 tracking-tight">
                  {logo}
                </div>
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default SocialMarquee;
